import React, { useEffect, useRef } from "react"
import { departmentMembershipFacilityShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import DepartmentMembershipFacilityDepartment from "./DepartmentMembershipFacilityDepartment"

const DepartmentMembershipFacility = ({ departmentMembershipFacility }) => {
  const { departments, name } = departmentMembershipFacility

  const itemRowRef = useRef()

  useEffect(() => {
    itemRowRef.current?.expand()
  }, [])

  return (
    <ItemRow
      collapsable
      itemRowHeaderContent={name}
      itemRowBody={(
        <>
          {
            departments.map((department) => (
              <DepartmentMembershipFacilityDepartment
                key={department.id}
                departmentMembershipFacilityDepartment={department}
              />
            ))
          }
        </>
      )}
      ref={itemRowRef}
    />
  )
}

DepartmentMembershipFacility.propTypes = {
  departmentMembershipFacility: departmentMembershipFacilityShape.isRequired,
}

export default DepartmentMembershipFacility
